const Link = {
  baseStyle: {
    textDecor: 'underline',
    textUnderlineOffset: '0.25em',
  },
};

export default Link;
